import { create } from 'zustand'

interface DeviceInfoStore {
    deviceId: string | null
    token_notification: string | null
    setDeviceId: (deviceId: string | null) => void
    setTokenNotification:  (token_notification: string | null) => void
}

export const useDeviceStore = create<DeviceInfoStore>((set) => ({
    deviceId: null,
    token_notification: null,
    setDeviceId: (deviceId) => set({ deviceId }),
    setTokenNotification: (token_notification) => set({ token_notification }),
}))

